import setImageOptions from "app/media/helpers/setImageOptions";
import { UmbracoImage } from "app/media/models/media.interface";
import productUrl from "pages/Catalog/pages/CategoryPage/helpers/productUrl";
import { SiteSetting } from "../models/settings.model";
import { PAGE_TYPE } from "../pages/page.types";

/* Getting meta data for head from page content */
interface PageMeta {
    language: string;
    metaTitle: string;
    metaDescription: string;
    metaKeywords: string;
    metaCanonical: string;
    robots: string;
    socialTitle: string;
    socialDescription: string;
    socialImage: string;
    url: string;
}

const getImageUrl = (umbracoImage?: UmbracoImage): string | undefined => {
    if (umbracoImage) {
        const crop = umbracoImage.crops?.find((crop) => crop.alias === "square");
        return setImageOptions(umbracoImage?.url, 1280, umbracoImage.umbracoExtension, crop, umbracoImage.focalPoint, 1);
    } else {
        return undefined;
    }
};

export default (page: PAGE_TYPE, settings: SiteSetting): PageMeta => {
    let language = "";
    let metaTitle = "";
    let metaDescription = "";
    let metaKeywords = "";
    let metaCanonical = "";
    let robots = "";
    let socialTitle = "";
    let socialDescription = "";
    let socialImage = "";
    let url = "";

    if (page) {
        switch (page._contentType) {
            case "homePage":
            case "contentPage": {
                language = page._culture || "da-dk";
                metaTitle = page.metaTitle || page._name || "Danish Bakery";
                metaDescription = page.metaDescription || "";
                metaKeywords = page.metaKeywords || "";
                metaCanonical = page.canonical || page._url || "";
                robots = `${page.metaAllowIndexing ? "index" : "noindex"},${page.metaAllowFollowing ? "follow" : "nofollow"}`;
                socialTitle = page.socialTitle || page.metaTitle || settings?.fallbackSocialTitle || page._name || "Danish Bakery";
                socialDescription = page.socialDescription || page.metaDescription || settings?.fallbackSocialDescription || "";
                socialImage = getImageUrl(page.socialImage) || getImageUrl(settings?.fallbackSocialImage) || "";
                url = page._url || `${window.location.origin}${window.location.pathname}`;
                break;
            }
            case "product": {
                language = page.language || "da-dk";
                metaTitle = page.metaTitle || page.itemName || "Danish Bakery";
                metaDescription = page.metaDescription || "";
                socialTitle = page.metaTitle || settings?.fallbackSocialTitle || page.itemName || "Danish Bakery";
                socialDescription = page.metaDescription || settings?.fallbackSocialDescription || "";
                url = productUrl(page.sku, page.language) || `${window.location.origin}${window.location.pathname}`;
                break;
            }
            case "category": {
                language = page.category?.language || "da-dk";
                metaTitle = page.metaTitle || page.category?.primaryTitle || "Danish Bakery";
                metaDescription = page.metaDescription || "";
                socialTitle = page.metaTitle || settings?.fallbackSocialTitle || page.category?.primaryTitle || "Danish Bakery";
                socialDescription = page.metaDescription || settings?.fallbackSocialDescription || "";
                url = `${window.location.origin}${window.location.pathname}`;
                break;
            }
        }
    }

    // TODO: Make a prettier return type
    return {
        language: language,
        metaTitle: metaTitle,
        metaDescription: metaDescription,
        metaKeywords: metaKeywords,
        metaCanonical: metaCanonical,
        robots: robots,
        socialTitle: socialTitle,
        socialDescription: socialDescription,
        socialImage: socialImage,
        url: url,
    };
};
